jQuery( function($){

    var $slider_string  = '.js-slider-metro';
    var $slider         = $($slider_string);

    $slider.each( function (i, el) {
        var $this               = $(el);
        var $slider__slides     = $this.find($slider_string+'__slides');
        var $slider__controls   = $this.find($slider_string+'__controls');

        $slider__slides.slick({
            dots: true,
            arrows: false,
            infinite: true,
            // speed: 300,
            autoplay: false,
            // autoplaySpeed: 3000,
            slidesToShow: 1,
            // slidesToScroll: 1,
            centerMode: true,
            centerPadding: 0,
            variableWidth: true,
            // dotsClass: 'slider__dots',
            appendDots: $slider__controls,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        // centerMode: false,
                        variableWidth: false,
                    }
                }
            ]
        });
    });

});
